import request from './request'

/**
 * 傳送發送驗證碼的email
 * @param {string} inputEmail - 接收驗證碼的email
 * @returns {Promise} axios的Promise物件
 */
function sendCaptcha(inputEmail) {
  return request({
    url: '/frontRandom/sendCaptcha',
    method: 'post',
    params: { inputEmail },
  })
}

/**
 * 驗證碼驗證
 * @param {Object} data - 含有inputEmail和captcha的物件
 * @param {string} data.inputEmail - 接收驗證碼的email
 * @param {string} data.captcha - 驗證碼
 * @returns {Promise} axios的Promise物件
 */
function checkCaptcha(data) {
  return request({
    url: '/frontRandom/checkCaptcha',
    method: 'post',
    data: data,
  })
}

/**
 * 驗證確認碼
 * @param {string} inputEmail - 接收驗證碼的email
 * @param {string} applyDepartment - 申請科系
 * @returns {Promise} axios的Promise物件
 */
function checkConfirm(inputEmail, applyDepartment) {
  return request({
    url: '/frontRandom/checkConfirm',
    method: 'get',
    params: { inputEmail, applyDepartment },
  })
}

export default {
  sendCaptcha,
  checkCaptcha,
  checkConfirm,
}
